/**
 * Payment Provider Registry
 *
 * Single source of truth for the active payment provider.
 * Set NEXT_PUBLIC_PAYMENT_PROVIDER=airwallex for Airwallex (embedded element).
 */

import { airwallexPaymentProvider } from "./providers/airwallexProvider";
import { mockPaymentProvider } from "./providers/mockProvider";
import type { PaymentMethod, PaymentProvider } from "./types";

const DEFAULT_PROVIDER_ID = "mock-regional";

const providers: Record<string, PaymentProvider> = {
  "mock-regional": mockPaymentProvider,
  airwallex: airwallexPaymentProvider,
};

export function getPaymentProvider(): PaymentProvider {
  const id = process.env.NEXT_PUBLIC_PAYMENT_PROVIDER ?? DEFAULT_PROVIDER_ID;
  const provider = providers[id];
  if (!provider) {
    throw new Error(`Payment provider "${id}" not found`);
  }
  return provider;
}

export function getAvailablePaymentMethods(): PaymentMethod[] {
  return getPaymentProvider().supportedMethods;
}
